<template>
  <UBadge
    v-if="row.slug === 'ax_card_status_change'"
    :color="row.ax_data?.decrypted_result?.status === 'INACTIVE' ? 'red' : row.ax_data?.decrypted_result?.status === 'ACTIVE' ? 'green' : 'gray'"
    :label="row.ax_data?.decrypted_result?.status === 'INACTIVE' ? $t('kard_block') : $t('izm_status')"
    variant="solid"
  />
  <UBadge
    v-else-if="row.slug === 'ax_blue_c_activated'"
    color="green"
    :label="$t('activatsiya_karty')"
    variant="solid"
  />
  <UBadge
    v-else-if="row.slug === 'ax_blue_c_issue_order'"
    color="blue"
    :label="$t('zayavka_na_vipusl_karty')"
    variant="solid"
  />
  <UBadge
    v-else-if="row.slug === 'ax_card_recharge_result'"
    color="blue"
    :label="$t('popolnenie_karty')"
    variant="solid"
  />
  <UBadge
    v-else-if="row.slug === 'ag_usdt_trc20'"
    color="violet"
    :label="$t('agregatsiya_usdt')"
    variant="soft"
  />
  <UBadge
    v-else-if="row.slug === 'ax_transaction_verification_code'"
    color="gray"
    :label="$t('kod_podtverjdenia_transactsii')"
    variant="solid"
  />
  <UBadge
    v-else-if="row.slug === 'blue_c_topup_order_new'"
    color="blue"
    :label="$t('zayavka_na_popoln')"
    variant="solid"
  />
  <UBadge
    v-else-if="row.slug === 'payment_for_issue_blue_c'"
    color="yellow"
    :label="$t('oplata_za_vipusk')"
    variant="solid"
  />
  <UBadge
    v-else-if="row.slug === 'user_deposit_usdt_trc20'"
    color="green"
    :label="$t('deposit_usdt_trc20')"
    variant="solid"
  />
  <UBadge
    v-else-if="['asinx_blue_mc_issue_order', 'hipay_blue_mc_issue_order'].includes(row.slug)"
    color="blue"
    :label="$t('zayavka_na_v')"
    variant="solid"
  />
  <UBadge
    v-else-if="row.slug === 'blue_c_update_otp_email_success'"
    color="green"
    :label="$t('blue_c_update_otp_email_success')"
    variant="solid"
  />
  <UBadge
    v-else-if="row.slug === 'user_registered'"
    color="green"
    :label="$t('user_registered')"
    variant="solid"
  />
  <UBadge
    v-else-if="['asinx_blue_mc_activated', 'hipay_blue_mc_activated'].includes(row.slug)"
    color="green"
    :label="$t('activ_card')"
    variant="solid"
  />
  <UBadge
    v-else-if="row.slug === 'cs_issue_order_partner_commission'"
    color="orange"
    :label="$t('cs_issue_order_partner_commission')"
    leading-icon="i-mdi-credit-card-plus"
    variant="soft"
  />
  <UBadge
    v-else-if="row.slug === 'cs_topup_order_partner_commission'"
    color="orange"
    :label="$t('cs_topup_order_partner_commission')"
    leading-icon="i-streamline-money-atm-card-2-deposit-money-payment-finance-atm-withdraw"
    variant="soft"
  />
  <UBadge
    v-else-if="row.slug === 'ax_transaction_created'"
    :color="row.ax_data?.decrypted_result?.transaction?.transCurrencyAmt && String(row.ax_data?.decrypted_result?.transaction?.transCurrencyAmt).trim().startsWith('+')
      ? 'yellow'
      : (row.ax_data?.decrypted_result?.transaction?.authType === 'PURCHASE'
      ? row.ax_data.decrypted_result.transaction.transStatus === 'PENDING'
         ? 'yellow'
         : row.ax_data.decrypted_result.transaction.transStatus === 'DECLINED'
           ? 'red'
           : 'green'
      : 'gray')"
    :label="row.ax_data?.decrypted_result?.transaction?.transCurrencyAmt && String(row.ax_data?.decrypted_result?.transaction?.transCurrencyAmt).trim().startsWith('+')
      ? $t('refund')
      : (row.ax_data?.decrypted_result?.transaction?.authType === 'PURCHASE' ? $t('card_purch') : (row.ax_data?.decrypted_result?.transaction?.authType || '—'))"
    variant="solid"
  />
  <UBadge
    v-else
    color="gray"
    label="—"
    variant="solid"
  />
</template>

<script setup lang="ts">
defineProps<{
  row: any
}>()
</script>
